// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"297":"data-monitor-worker","594":"ws-data-monitor-worker","919":"obd-data-monitor-worker"}[chunkId] + ".1793782279064.js";
};